(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("utils", [], factory);
	else if(typeof exports === 'object')
		exports["utils"] = factory();
	else
		root["utils"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(3);

var iterableToArrayLimit = __webpack_require__(4);

var unsupportedIterableToArray = __webpack_require__(5);

var nonIterableRest = __webpack_require__(7);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(6);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "throttle", function() { return /* reexport */ throttle; });
__webpack_require__.d(__webpack_exports__, "once", function() { return /* reexport */ once; });
__webpack_require__.d(__webpack_exports__, "sleep", function() { return /* reexport */ sleep; });
__webpack_require__.d(__webpack_exports__, "deepcopy", function() { return /* reexport */ src_deepcopy; });
__webpack_require__.d(__webpack_exports__, "loadScript", function() { return /* reexport */ src_loadScript; });
__webpack_require__.d(__webpack_exports__, "versionCompare", function() { return /* reexport */ versionCompare; });
__webpack_require__.d(__webpack_exports__, "jsonToUrl", function() { return /* reexport */ jsonToUrl; });
__webpack_require__.d(__webpack_exports__, "encodeURIJson", function() { return /* reexport */ url_encodeURIJson; });
__webpack_require__.d(__webpack_exports__, "setUrlParams", function() { return /* reexport */ url_setUrlParams; });
__webpack_require__.d(__webpack_exports__, "strToJson", function() { return /* reexport */ url_strToJson; });
__webpack_require__.d(__webpack_exports__, "urlToJson", function() { return /* reexport */ url_urlToJson; });
__webpack_require__.d(__webpack_exports__, "convertProtocol", function() { return /* reexport */ convertProtocol; });
__webpack_require__.d(__webpack_exports__, "to", function() { return /* reexport */ src_to; });
__webpack_require__.d(__webpack_exports__, "isArray", function() { return /* reexport */ isArray; });
__webpack_require__.d(__webpack_exports__, "isBoolean", function() { return /* reexport */ isBoolean; });
__webpack_require__.d(__webpack_exports__, "isString", function() { return /* reexport */ isString; });
__webpack_require__.d(__webpack_exports__, "isObject", function() { return /* reexport */ isObject; });
__webpack_require__.d(__webpack_exports__, "isHtmlElement", function() { return /* reexport */ isHtmlElement; });
__webpack_require__.d(__webpack_exports__, "isFunction", function() { return /* reexport */ isFunction; });
__webpack_require__.d(__webpack_exports__, "isUndefined", function() { return /* reexport */ isUndefined; });
__webpack_require__.d(__webpack_exports__, "isDefined", function() { return /* reexport */ isDefined; });
__webpack_require__.d(__webpack_exports__, "isTruthy", function() { return /* reexport */ isTruthy; });
__webpack_require__.d(__webpack_exports__, "isNull", function() { return /* reexport */ isNull; });
__webpack_require__.d(__webpack_exports__, "isEmptyObject", function() { return /* reexport */ types_isEmptyObject; });
__webpack_require__.d(__webpack_exports__, "EventHub", function() { return /* reexport */ event_hub; });
__webpack_require__.d(__webpack_exports__, "cookie", function() { return /* reexport */ src_cookie; });
__webpack_require__.d(__webpack_exports__, "storage", function() { return /* reexport */ storage; });
__webpack_require__.d(__webpack_exports__, "device", function() { return /* reexport */ device; });

// CONCATENATED MODULE: ./src/to.js
// 方便解决异常
var to = function to(promise) {
  return promise.then(function (data) {
    return [null, data];
  })["catch"](function (err) {
    return [err];
  });
};

/* harmony default export */ var src_to = (to);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__(0);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(1);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/index.js



/**
 * 节流函数
 * 默认500ms执行一次
 * @param {*} fn
 * @param {*} time
 */
var throttle = function throttle(fn) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer = null;
  return function () {
    if (timer === null) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      fn.apply(this, args);
      timer = setTimeout(function () {
        timer = null;
      }, time);
    }
  };
};
var once = function once(fn) {
  var result;
  var func = fn;
  return function () {
    if (func) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      result = func.apply(this, args);
      func = null;
    }

    return result;
  };
};
var sleep = function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}; // 深拷贝

var src_deepcopy = function deepcopy(obj) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var find = function find(list, f) {
    return list.filter(f)[0];
  };

  if (obj === null || typeof_default()(obj) !== 'object') {
    return obj;
  }

  var hit = find(cache, function (c) {
    return c.original === obj;
  });

  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};
  cache.push({
    original: obj,
    copy: copy
  });
  Object.keys(obj).forEach(function (key) {
    copy[key] = deepcopy(obj[key], cache);
  });
  return copy;
}; // 加载js

var src_loadScript = function loadScript(url, success) {
  var _window$document$getE = window.document.getElementsByTagName('script'),
      _window$document$getE2 = slicedToArray_default()(_window$document$getE, 1),
      firstScript = _window$document$getE2[0];

  var script = window.document.createElement('script');
  script.src = url;
  script.type = 'text/javascript';
  script.async = false;
  firstScript.parentNode.insertBefore(script, firstScript);

  if (typeof success === 'function') {
    script.onload = success;
  }

  return script;
}; // 版本号比较

var versionCompare = function versionCompare() {
  var preVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lastVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preList = preVersion.split('.');
  var lastList = lastVersion.split('.');
  var maxL = Math.max(preList.length, lastList.length);
  var result = 0;

  for (var i = 0; i < maxL; i++) {
    var preValue = preList.length > i ? preList[i] : 0;
    var preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
    var lastValue = lastList.length > i ? lastList[i] : 0;
    var lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);

    if (preNum < lastNum) {
      result = -1;
      break;
    } else if (preNum > lastNum) {
      result = 1;
      break;
    }
  }

  return result;
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/types.js


/**
 * 判断是否是数字
 */
var isNum = function isNum(s) {
  if (s !== null && s !== '') {
    return !isNaN(s);
  }

  return false;
};
var isArray = function isArray(arr) {
  return Array.isArray(arr);
};
var isBoolean = function isBoolean(val) {
  return typeof val === 'boolean';
};
var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
var isHtmlElement = function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
};
var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};
var isUndefined = function isUndefined(val) {
  return val === undefined;
};
var isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};
var isTruthy = function isTruthy(val) {
  return val && val !== undefined && val !== null && val !== '';
};
var isNull = function isNull(value) {
  return value === null;
};
/**
 *
 * @desc   判断`obj`是否为空
 * @param  {Object} obj
 * @return {Boolean}
 */

var types_isEmptyObject = function isEmptyObject(obj) {
  if (!obj || typeof_default()(obj) !== 'object' || Array.isArray(obj)) {
    return false;
  }

  return !Object.keys(obj).length;
};
// CONCATENATED MODULE: ./src/url.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @desc   将对象用 “&” 拼接成url 格式
 * @param  {Object} obj
 * @return {String}
 */

/**
 * 将json转为url参数
 * 不能包含特殊字符
 * json可控的情况下可调用此方法
 * @param {*} obj
 */

var jsonToUrl = function jsonToUrl() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = Object.keys(obj);
  return keys.map(function (key) {
    return "".concat(key, "=").concat(obj[key]);
  }).join('&');
};
/**
 * 将json转为url参数
 * 特殊字符会encodeURI
 * json不可知，可能会有特殊字符，建议调用此方法
 * @param {*} obj
 */

var url_encodeURIJson = function encodeURIJson() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
  var pairs = [];
  var keys = Object.keys(obj);
  keys.forEach(function (key) {
    var value = obj[key];

    if (['', undefined, null].includes(value)) {
      return;
    }

    if (isArray(value)) {
      for (var i = 0; i < value.length; ++i) {
        pairs.push("".concat(encodeURIComponent("".concat(key, "[").concat(i, "]")), "=").concat(encodeURIComponent(value[i])));
      }

      return;
    }

    pairs.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key])));
  });
  return pairs.join(split);
};
/**
 * 设置url中参数的值
 * 对象属性设置为空，认为是删除该参数
 * @param {*} url
 * @param {*} params
 */

var url_setUrlParams = function setUrlParams() {
  var originUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var url = originUrl;
  var params = opts;
  /**
   * 如果只传了一个参数，默认url 为  window.location.href
   */

  if (isObject(url)) {
    params = _objectSpread({}, url);
    url = window.location.href;
  }

  var paramsKeys = Object.keys(params);
  var urlJson = url_urlToJson(url);
  paramsKeys.forEach(function (key) {
    // 设置参数为空，即删除此参数
    if (params[key] === '') {
      delete urlJson[key];
    } else {
      urlJson[key] = params[key];
    }
  });

  var _url$split = url.split('?'),
      _url$split2 = slicedToArray_default()(_url$split, 1),
      rel = _url$split2[0];

  if (Object.keys(urlJson).length !== 0) {
    rel = "".concat(rel, "?").concat(jsonToUrl(urlJson));
  }

  return rel;
};
/**
 * 将字符串转为对象
 * strToJson('a=1;b=2;', ';')
 */

var url_strToJson = function strToJson(str) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  if (!str) {
    return {};
  }

  var dataObj = {};
  var strArr = str.split(key);

  for (var i = 0, len = strArr.length; i < len; i++) {
    var paramArr = strArr[i].split('=');

    var _paramArr = slicedToArray_default()(paramArr, 2),
        _key = _paramArr[0],
        val = _paramArr[1];

    dataObj[_key] = val;
  }

  return dataObj;
};
/**
 * 将url后的参数转为对象
 * @param {*} url
 */

var url_urlToJson = function urlToJson() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var urlObject = {};
  var index = url.indexOf('?');

  if (index === -1) {
    return urlObject;
  }

  var urlString = url.substring(index + 1);
  var urlArray = urlString.split('&');

  for (var i = 0, len = urlArray.length; i < len; i++) {
    var urlItem = urlArray[i];
    var item = urlItem.split('=');

    var _item = slicedToArray_default()(item, 2),
        key = _item[0],
        value = _item[1];

    urlObject[key] = value;
  }

  return urlObject;
};
/**
 * 将 url中的 http | https转为 protocol
 * @param {*} url
 * @param {*} protocol
 * @returns { String }
 */

var convertProtocol = function convertProtocol() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var proto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.protocol;
  var protocol = proto.replace(':', '');
  return url.replace(/^(http:|https:)/i, "".concat(protocol, ":"));
};
// CONCATENATED MODULE: ./src/event-hub.js

var EventHub = {
  mix: function mix(d, src, m) {
    var des = d;
    var map = m;

    if (typeof_default()(des) !== 'object') {
      return des;
    }

    map = map || function (d, s, i) {
      // 这里要加一个des[i]，是因为要照顾一些不可枚举的属性
      if (!(des[i] || i in des)) {
        return s;
      }

      return d;
    };

    if (map === true) {
      map = function map(d, s) {
        return s;
      };
    }

    var keys = Object.keys(src);
    keys.forEach(function (i) {
      des[i] = map(des[i], src[i], i); // 如果返回undefined，尝试删掉这个属性

      if (des[i] === undefined) {
        delete des[i];
      }
    });
    return des;
  },
  createEvents: function createEvents(obj) {
    var events = {};
    EventHub.mix(obj, {
      on: function on(evtType, handler) {
        events[evtType] = events[evtType] || [];
        events[evtType].push(handler);
        return obj;
      },
      fire: function fire(evtType) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var args = opts;
        EventHub.mix(args, {
          type: evtType,
          target: obj,
          preventDefault: function preventDefault() {
            args.returnValue = false;
          }
        });
        var handlers = events[evtType] || [];
        handlers.forEach(function (handler) {
          handler(args);
        });
        return args.returnValue !== false;
      }
    });
    return obj;
  }
}; // 注册自定义事件到EventHub.events

EventHub.events = EventHub.events || {};
/* harmony default export */ var event_hub = (EventHub);
// CONCATENATED MODULE: ./src/cookie.js


var cookie = {
  set: function set(name, val) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var options = opts;
    var value = val;

    if (value === null) {
      value = '';
      options.expires = -1;
    }

    var expires = '';

    if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
      var date;

      if (typeof options.expires === 'number') {
        date = new Date();
        date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
      } else {
        date = options.expires;
      }

      expires = "; expires=".concat(date.toUTCString());
    }

    options.path = options.path || '/';
    options.domain = options.domain || location.hostname;
    var path = "; path=".concat(options.path);
    var domain = "; domain=".concat(options.domain);
    var secure = options.secure ? '; secure' : '';
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
  },
  get: function get(name) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var len = cookies.length;
    var ret = name ? '' : Object.create(null);

    for (var i = 0; i < len; i++) {
      var _cookies$i$split = cookies[i].split('='),
          _cookies$i$split2 = slicedToArray_default()(_cookies$i$split, 2),
          key = _cookies$i$split2[0],
          value = _cookies$i$split2[1];

      if (key === name) {
        ret = value;
        break;
      }

      if (!name) {
        ret[key] = value;
      }
    }

    return ret;
  },
  del: function del(val, options) {
    var _this = this;

    if (isArray(val)) {
      val.forEach(function (item) {
        _this.set(item, null, options);
      });
    } else {
      this.set(val, null, options);
    }
  }
};
/* harmony default export */ var src_cookie = (cookie);
// CONCATENATED MODULE: ./src/storage.js
var LS = {
  // 过期时间，默认1个月
  age: 1 * 30 * 24 * 60 * 60 * 1000,

  /**
   * 设置过期时间
   * @param age
   * @returns { exports }
   */
  setAge: function setAge(age) {
    this.age = age;

    if (this.key) {
      this.set(this.key, this.value);
    }

    return this;
  },

  /**
   * 设置 localStorage
   * @param key
   * @param value
   */
  set: function set(key, value) {
    var isObject = value instanceof Object;
    var time = new Date().getTime();
    var age = time + this.age;
    var storage = {
      time: time,
      age: age,
      isObject: isObject
    }; // 方便链式调用

    this.key = key;
    this.value = value;
    localStorage.removeItem(key); // 如果是对象，新建一个对象把 value 存起来

    storage.value = value;
    localStorage.setItem(key, JSON.stringify(storage));
    return this;
  },

  /**
   * 判断一个 localStorage 是否过期
   * @param key
   * @returns {boolean}
   */
  isExpire: function isExpire(key) {
    var isExpire = true;
    var value = localStorage.getItem(key);
    var now = new Date().getTime();

    if (value) {
      var storage = JSON.parse(value); // 当前时间是否大于过期时间

      isExpire = now > storage.age;
    }

    return isExpire;
  },

  /**
   * 获取某个 localStorage 值
   * @param key
   * @returns {*}
   */
  get: function get(key) {
    var isExpire = this.isExpire(key); // 如果已经过期，则删除

    if (isExpire) {
      localStorage.removeItem(key);
      return null;
    }

    var value = localStorage.getItem(key);
    var storage = JSON.parse(value);
    return storage.value;
  }
};
/* harmony default export */ var storage = (LS);
// CONCATENATED MODULE: ./src/device.js
/* harmony default export */ var device = ({
  ua: function ua() {
    return window.navigator.userAgent.toLowerCase();
  },
  isIphone: function isIphone() {
    return /iphone/.test(this.ua());
  },
  isHuawei: function isHuawei() {
    return /huawei/.test(this.ua());
  },
  isHonor: function isHonor() {
    return /honor/.test(this.ua());
  },
  isOppo: function isOppo() {
    return /oppo/.test(this.ua());
  },
  isOppoR15: function isOppoR15() {
    return /pacm00/.test(this.ua());
  },
  isVivo: function isVivo() {
    return /vivo/.test(this.ua());
  },
  isXiaomi: function isXiaomi() {
    return /mi\s/.test(this.ua());
  },
  isXiaomi2s: function isXiaomi2s() {
    return /mix\s/.test(this.ua());
  },
  isRedmi: function isRedmi() {
    return /redmi/.test(this.ua());
  },
  isSamsung: function isSamsung() {
    return /sm-/.test(this.ua());
  }
});
// CONCATENATED MODULE: ./index.js









/* harmony default export */ var index_0 = __webpack_exports__["default"] = ({
  throttle: throttle,
  once: once,
  sleep: sleep,
  deepcopy: src_deepcopy,
  loadScript: src_loadScript,
  versionCompare: versionCompare,
  jsonToUrl: jsonToUrl,
  encodeURIJson: url_encodeURIJson,
  setUrlParams: url_setUrlParams,
  strToJson: url_strToJson,
  urlToJson: url_urlToJson,
  convertProtocol: convertProtocol,
  to: src_to,
  isArray: isArray,
  isBoolean: isBoolean,
  isString: isString,
  isObject: isObject,
  isHtmlElement: isHtmlElement,
  isFunction: isFunction,
  isUndefined: isUndefined,
  isDefined: isDefined,
  isTruthy: isTruthy,
  isNull: isNull,
  isEmptyObject: types_isEmptyObject,
  EventHub: event_hub,
  cookie: src_cookie,
  storage: storage,
  device: device
});

/***/ })
/******/ ]);
});